import React from "react";

/**
 * The section switcher on a calf sheet.
 *
 * There are nine sections, which is far more than fits across a phone. A single
 * scrolling strip put five of them out of sight with nothing to suggest they were
 * there — and a section nobody can see is a section nobody fills in. So on a
 * narrow screen the tabs wrap and every one is visible at once; from `md` up,
 * where there is room, they sit on one line as a segmented control.
 */
function Tabs({ value, onChange, tabs, className = "" }) {
  return (
    <div
      role="tablist"
      className={
        "flex flex-row flex-wrap gap-1 rounded-lg bg-stone-100 p-1 md:flex-nowrap md:border md:border-stone-200 dark:border-slate-700 dark:bg-slate-800 " +
        className
      }
    >
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={value === tab.id}
          onClick={() => onChange(tab.id)}
          className={
            // tighter horizontally on mobile so nine tabs fit in two rows rather
            // than three, and tall enough to be a comfortable tap target
            "flex-shrink-0 rounded-md px-2.5 py-3 text-sm transition-all duration-100 md:px-3 md:py-1 " +
            (value === tab.id
              ? "bg-white font-medium text-amber-500 shadow dark:bg-slate-700 dark:text-amber-300"
              : "text-stone-500 hover:text-stone-800 dark:text-slate-300 dark:hover:text-white")
          }
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}

export default Tabs;
